import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';

const ComingSoonContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.theme.colors.gradients.card};
  padding: 2rem;
  padding-top: 120px;
`;

const ComingSoonCard = styled(motion.div)`
  background: white;
  border-radius: 30px;
  padding: 3rem;
  text-align: center;
  max-width: 600px;
  width: 100%;
  box-shadow: ${props => props.theme.shadows.xl};
`;

const IconContainer = styled.div`
  font-size: 5rem;
  margin-bottom: 2rem;
  animation: pulse 2s infinite;
  
  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 1rem;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Subtitle = styled.h2`
  font-size: 1.5rem;
  color: ${props => props.theme.colors.text};
  margin-bottom: 1.5rem;
  font-weight: 600;
`;

const Message = styled.p`
  font-size: 1.2rem;
  color: ${props => props.theme.colors.textLight};
  margin-bottom: 2rem;
  line-height: 1.6;
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 2rem;
`;

const ActionButton = styled(Link)`
  display: inline-block;
  padding: 1rem 2rem;
  border-radius: 25px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  
  &.btn-primary {
    background: linear-gradient(45deg, ${props => props.theme.colors.primary}, ${props => props.theme.colors.secondary});
    color: white;
    box-shadow: 0 5px 15px rgba(46, 204, 113, 0.4);
    
    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 25px rgba(46, 204, 113, 0.6);
    }
  }
  
  &.btn-outline {
    background: transparent;
    border: 2px solid ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.primary};
    
    &:hover {
      background: ${props => props.theme.colors.primary};
      color: white;
    }
  }
`;

const ComingSoon = () => {
  return (
    <ComingSoonContainer>
      <Helmet>
        <title>Kundenportal - Bald verfügbar - Der Ponystall</title>
        <meta name="description" content="Das Kundenportal ist in Kürze verfügbar. Wir arbeiten daran, Ihnen den besten Service zu bieten." />
      </Helmet>

      <ComingSoonCard
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
      >
        <IconContainer>🚧</IconContainer>
        
        <Title>Bald verfügbar</Title>
        <Subtitle>Kundenportal</Subtitle>
        
        <Message>
          Wir arbeiten mit Hochdruck daran, Ihnen ein modernes Kundenportal zur Verfügung zu stellen. 
          Hier können Sie in Kürze Ihre Buchungen verwalten, Rechnungen einsehen und vieles mehr.
        </Message>

        <Message style={{ fontSize: '1rem', fontStyle: 'italic', color: '#888' }}>
          Haben Sie Fragen? Kontaktieren Sie uns gerne unter{' '}
          <a href="mailto:derponystall@gmx.de" style={{ color: '#2ecc71', textDecoration: 'none' }}>
            derponystall@gmx.de
          </a>
          {' '}oder telefonisch unter{' '}
          <a href="tel:01621353794" style={{ color: '#2ecc71', textDecoration: 'none' }}>
            0162 1353794
          </a>.
        </Message>

        <ActionButtons>
          <ActionButton to="/" className="btn-primary">
            Zur Startseite
          </ActionButton>
          <ActionButton to="/kurse" className="btn-outline">
            Kurse entdecken
          </ActionButton>
        </ActionButtons>
      </ComingSoonCard>
    </ComingSoonContainer>
  );
};

export default ComingSoon;






